<div id="wrapper" class="wrapper home-wrapper" *ngIf="!isAuthScreen">
  <!-- left-side -->
  <app-new-sidebar *ngIf="!hideSidebar && isNewSidebarEnabled" (toggleEvent)="toggleEvent($event)"></app-new-sidebar>
  <app-sidebar *ngIf="!hideSidebar && !isNewSidebarEnabled" (toggleEvent)="toggleEvent($event)"></app-sidebar>
  <!-- Begin page content -->
  <main *ngIf="!hideMainContent"
    id="main-content"
    role="main"
    tabindex="-1"
    class="middle-area-dashboard main-dashboard"
    [ngClass]="toggelEvent ? 'dashboard-expand' : ''"
  >
    <div class="main-middle-area">
      <!--  Header  -->
      <header
        *ngIf="!isHeaderHidden"
        role="banner"
        aria-label="Site header"
        tabindex="-1"
        class="header header-dashboard"
        [ngClass]="toggelEvent ? 'collapsed-header' : ''"
      >
        <nav aria-label="Search" tabindex="-1" class="navbar navbar-dark">
          <div class="container-fluid d-block">
            <div class="row col-header-row">
              <div class="col-lg-12 col-12">
                <div class="nav-dashboard-row">
                  <div class="nav-dashboard-left">
                    <div class="heading-div">
                      <!-- <h1><b>Hello,</b> {{ getFullName() }}</h1> -->
                    </div>
                  </div>
                  <div class="nav-dashboard-right">
                    <div class="search-box-root search-new-box-root mr-0">
                      <div class="search-div search-new-div">
                        <!-- <button (click)="navigateBack()" class="btn btn-icon" title="Go Back">
                          <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 24 24" width="30"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></svg>
                        </button>
                        <button (click)="refreshContent()" title="Refresh" class="btn btn-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 24 24" width="30"><path d="M0 0h24v24H0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
                        </button> -->
                        <div
                          class="search-box"
                          [ngClass]="isSearchVisible ? 'full-width-input' : ''"
                        >
                          <input
                            type="text"
                            placeholder="Search..."
                            (keyup)="searchText($event)"
                            class="form-control form-search"
                            #input
                          />
                          <button
                            class="btn btn-default btn-search"
                            id="search-box-form"
                            (click)="toggleSearch(input)"
                          >
                            <i class="icon-search"></i>
                            <i class="icon-close icon-search-cancel"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <!-- End of header -->
      <div class="main-section">
        <div class="main-div">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12 col-md-12">
                <app-sub-header></app-sub-header>
                <router-outlet *ngIf="!isAuthScreen"></router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
<router-outlet *ngIf="isAuthScreen && hideMainContent && hideSidebar"></router-outlet>
